import SparkMD5 from 'spark-md5'
/**
 * @description 判断是否是猎豹浏览器
 * @description 猎豹浏览器会存在 window.chrome.LiebaoGetVersion 的全局函数，用于获取浏览器版本
 * @type {*|boolean}
 */
export const isLiebao = window.chrome &&
  window.chrome.LiebaoGetVersion &&
  typeof window.chrome.LiebaoGetVersion === 'function'

/**
 * @description 比较猎豹浏览器版本， 大于返回1，等于返回 0,
 * @param currentVersion{string} // "8.0.0.20879"
 * @param compareVersion{string} // "8.0.0.20889"
 * @return {number}
 */
export const compareLiebaoVersion = function (currentVersion, compareVersion) {
  const currentVersionArray = currentVersion.split('.')
  const compareVersionArray = compareVersion.split('.')
  const length = compareVersionArray.length
  for (let index = 0; index < length; ++index) {
    const currentVersionNum = Number.parseInt(currentVersionArray[index])
    const compareVersionNum = Number.parseInt(compareVersionArray[index])
    if (currentVersionNum > compareVersionNum) {
      return 1
    } else if (currentVersionNum < compareVersionNum) {
      return -1
    }
  }
  return 0
}

/**
 * @description 计算文件的MD5
 * @param file
 * @return {Promise<string>}
 */
export const fileToMD5 = function (file) {
  return new Promise((resolve, reject) => {
    const blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
    const chunkSize = 2097152
    const chunks = Math.ceil(file.size / chunkSize)
    let currentChunk = 0
    const spark = new SparkMD5.ArrayBuffer()
    const fileReader = new FileReader()

    fileReader.onload = function (e) {
      spark.append(e.target.result)
      currentChunk++

      if (currentChunk < chunks) {
        loadNext()
      } else {
        resolve(spark.end())
      }
    }

    fileReader.onerror = function (error) {
      reject(error)
    }

    function loadNext () {
      const start = currentChunk * chunkSize
      const end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize

      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end))
    }

    loadNext()
  })
}

/**
 * @description 获取文件名的后缀
 * @example getFileType(xxxxx.pdf) => pdf
 * @example getFileType(xxxxx.PDF) => pdf
 * @param fileName
 * @return {string}
 */
export const getFileType = function (fileName) {
  return fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase()
}
